import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { FormEvent, ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { S_ErrorFeedback } from '../../../../design/feedback/errorFeedback/S_ErrorFeedback';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { InputStatus } from '../../../models/error.model';

interface IChangeEmailModalProps {
  show: boolean;
  passwordStatus: InputStatus;
  emailStatus: InputStatus;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  onPasswordChange: (password: string) => void;
  onPasswordBlur: () => void;
  onEmailChange: (email: string) => void;
  onEmailBlur: () => void;
}

export const ChangeEmailModal = observer((props: IChangeEmailModalProps): ReactElement => {
  const { t } = useTranslator();

  const handleSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    await props.onConfirm();
  };

  const valid = props.emailStatus.isValid && props.passwordStatus.isValid;

  return (
    <S_Modal
      isOpen={props.show}
      toggle={props.onCancel}
      headerText={t('change_email')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onCancel}
          >
            {t('cancel')}
          </Button>
          <ButtonWithLoader
            onClick={handleSubmit}
            disabled={!valid}
            loaderKey='change_email_loader'
          >
            {t('change_email')}
          </ButtonWithLoader>
        </>
      }
    >
      <ValidatedTextInput
        labelText={t('email')}
        isRequired
        type='email'
        placeholder={t('enter_email')}
        isValid={props.emailStatus.isValid}
        feedbacks={props.emailStatus.errorCodes}
        onChange={props.onEmailChange}
        onBlur={props.onEmailBlur}
      />
      <ValidatedTextInput
        labelText={t('password')}
        type='password'
        isRequired
        placeholder={t('enter_password')}
        enablePreview={true}
        isValid={props.passwordStatus.isValid}
        feedbacks={props.passwordStatus.errorCodes}
        onChange={props.onPasswordChange}
        onBlur={props.onPasswordBlur}
      />
      <S_ErrorFeedback>{t('change_email_assignments_delete_notification')}</S_ErrorFeedback>
    </S_Modal>
  );
});
